// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"mu_a zu_cw zu_jx zu_jo zu_a zu_j zu_pm zu_pn","SearchPanel__icon":"mu_b zu_sm zu_hb zu_ps zu_ry","SearchPanel__input":"mu_c zu_iv zu_cx zu_z"};